import React, { useMemo, useCallback } from 'react';
import Grid from 'e100-react-components/lib/components/Grid';
import IconButton from 'e100-react-components/lib/components/IconButton';
import { copyToClipboard } from 'common/utils/index';
import { EMPTY_STRING } from 'common/constants';

import useStyles from './useStyles';
import { INotice } from 'store/features/application/types/notice';

interface IProps {
  notice: INotice;
  onHide: () => void;
}

const Actions = ({ notice, onHide }: IProps) => {
  const classes = useStyles({ type: notice.type });
  const errorData = useMemo(
    () => JSON.stringify(notice.data || EMPTY_STRING, undefined, 2),
    [notice],
  );
  const onCopyError = useCallback(() => {
    copyToClipboard(errorData);
  }, [errorData]);

  return (
    <>
      <Grid container spacing={0}>
        {false && (
          <Grid item>
            <IconButton
              kind={'fileCopyOutlined'}
              onClick={onCopyError}
              color='inherit'
              classes={{
                icon: { root: classes.iconCopy },
                button: { root: classes.buttonCopy },
              }}
            />
          </Grid>
        )}
        <Grid item>
          <IconButton
            kind={'close'}
            onClick={onHide}
            color='secondary'
            classes={{
              icon: { root: classes.iconButton },
              button: { root: classes.button },
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Actions;
